import React from 'react';

const Imprint = () => {
  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6 max-w-3xl">
        <h1 className="text-4xl mb-8">Site Notice</h1>
        <div className="prose prose-stone max-w-none text-brand-800 space-y-6">
          <p>
            <strong>Amani Palms by Manolo Beach Resort</strong><br/>
            Dikoni Street<br/>
            9373 Zanzibar
          </p>
          <p>
            <strong>Commercial Register:</strong> Registration-N° Z0000076888<br/>
            <strong>Registration court:</strong> The Revolutionary Government of Sansibar
          </p>
          <p>
            <strong>Contact</strong><br/>
            Phone: +255 677 522 140<br/>
            E-mail: info@manoloresort.com
          </p>
          <p>
            <strong>VAT ID</strong><br/>
            Sales tax identification number according to Sect. 27 a of the Sales Tax Law:<br/>
            TIN: 144-311-000
          </p>
          <p>
            <strong>Information regarding professional liability insurance</strong><br/>
            Name and registered office of the insurer:<br/>
            The Heritage Insurance company Tanzania LTD<br/>
            Masaki Ikon, 4th floor Baines Avenue Plot No 1521<br/>
            P.O. Box 7390, Dar ses Sallam Tanzania
          </p>
          <p>
            Scope of insurance:<br/>
            Zanzibar
          </p>
          <p>
            <strong>Person responsible for editorial</strong><br/>
            Happy Whale Company LTD<br/>
            Uroa, P.O. Box 9373<br/>
            Dikoni Street
          </p>
          <p>
            <strong>Dispute resolution proceedings in front of a consumer arbitration board</strong><br/>
            We are not willing or obliged to participate in dispute resolution proceedings in front of a consumer arbitration board.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Imprint;